module.exports = __webpack_public_path__ + "static/media/AdamByrd-resume.843e5eb5.pdf";